import { type FunctionComponent } from "react";

import { useEditionValue } from "shared/lib/edition";
import { useGetHomeAsPath } from "shared/lib/router";

import { FooterVariant } from "scmp-app/components/app-footer";
import { page as HomePage } from "scmp-app/pages/home";

import { StyledBlackTextLogo, StyledLogoLink, StyledWhiteTextLogo } from "./styles";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
  variant?: FooterVariant.Dark;
};

export const FooterLogo: FunctionComponent<Props> = ({ className, onClick, variant }) => {
  const homeAsPath = useGetHomeAsPath();
  const edition = useEditionValue();
  const { pathname: homePagePathname } = HomePage.route({
    edition,
    slide: "main",
  });

  return (
    <StyledLogoLink
      anchorProps={{ "aria-label": "SCMP homepage" }}
      as={homeAsPath}
      className={className}
      onClick={() => onClick(homeAsPath)}
      pathname={homePagePathname}
    >
      {variant === FooterVariant.Dark ? <StyledWhiteTextLogo /> : <StyledBlackTextLogo />}
    </StyledLogoLink>
  );
};

FooterLogo.displayName = "FooterLogo";
